import React from "react";
import { withStyles } from "@material-ui/core/styles";
import { Storage } from "aws-amplify";
import { useState } from "react";
import { useEffect } from "react";
let tractor = require("../../assets/img/tractor-128.png");
let van = require("../../assets/img/van.png");
let bus = require("../../assets/img/bus.png");
let truck = require("../../assets/img/truck.png");
let trailer = require("../../assets/img/trailer.png");
let pickup = require("../../assets/img/pickup.png");

Storage.configure({
  AWSS3: {
    bucket: "calbitwebappuploadbucket1254-dev", //Your bucket name;
    region: "us-east-2" //Specify the region your bucket was created in;
  }
});
const styles = {
  card: {
    maxWidth: 345
  },
  media: {
    height: 140
  }
};
function VehicleCard(props) {
  // Supposing your item shape is something like {name: 'foo'}
  const { item, classes } = props;
  const [url, setUrl] = useState("");
  let src = "";
  const getUrl = async key => {
    let url = await Storage.get(key);
    setUrl(url);
  };
  src = utilGetVehicleImage(item.vehCategory);
  const changeRoute = () => {
    item.history.push("/defects/" + item.id);
  };
  const itemStyle = {
    display: "block",

    width: "100%",
    height: "100%",
    padding: "5px",

    backgroundColor: "white",
    cursor: "pointer",

    boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)",
    transition: "0.3s",
    borderRadius: "5px",
    "&:hover": {
      boxShadow: "0 8px 16px 0 rgba(0,0,0,0.2)"
    }
  };

  const name = {
    width: "100%",
    paddingTop: 8,
    paddingLeft: 8,
    paddingRight: 8,
    position: "relative",
    color: "#555",
    fontSize: "0.8em",
    lineHeight: "1.5",
    textTransform: "capitalize",
    cursor: "pointer"
  };
  useEffect(() => {
    if (item.mainPic) getUrl(item.mainPic.key);
    else setUrl(utilGetVehicleImage(item.vehCategory));
  }, []);
  // if (!item.hasDefects) return null
  return (
    <div style={{ ...itemStyle, paddingBottom: 20 }} onClick={changeRoute}>
      <img src={url} style={{ height: "50%", width: "100%" }}></img>
      <div style={name}>
        <span style={{ float: "left", paddingRight: "10px" }}>
          ID: <b>{item.name + "  "}</b>
        </span>
        <span style={{ float: "left" }}>
          Defects: <b>{item.defectCount}</b>
        </span>
        <span style={{ float: "left", paddingRight: "2px" }}>
          Inspection Due:
        </span>
        <span style={{ float: "left" }}>
          <b>{item.nextInspectionDue}</b>
        </span>
      </div>
    </div>
  );
}
const utilGetVehicleImage = vehCategory => {
  let src = "";
  switch (vehCategory) {
    case "TRACTOR":
      src = tractor;
      break;
    case "TRUCK":
      src = truck;
      break;
    case "TRAILER":
      src = trailer;
      break;
    case "VAN":
      src = van;
      break;
    case "BUS":
      src = bus;
      break;
    case "PICKUPTRUCK":
      src = pickup;
      break;
  }
  return src;
};
export default withStyles(styles)(VehicleCard);



// WEBPACK FOOTER //
// ./src/views/Defects/vehicleCard.jsx